import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.MailDelivery;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "MailDelivery.Phaser.IntroductionScene.1",
            "MailDelivery.Phaser.IntroductionScene.2",
            "MailDelivery.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/MailDeliveryGame/scenes/GameIntro.ts